import { Group, Line, Text } from 'react-konva';
import React from 'react';
import URLImage from './URLImage';

let endLineLength = 50;


class MeasurementLine extends React.Component {
    render() {
        let clickHandler = () => { if (this.props.showModal) this.props.showModal(this.props.label, this.props.length, this.props.inputChanged.bind(this), 0, this.props.maxValue); };
        return (
            <Group rotation={this.props.rotation} x={this.props.startx} y={this.props.starty} preventDefault={false} onClick={clickHandler}>
                <Line ref={(mainLine) => { this.mainLine = mainLine; }} stroke="red" points={[0, -endLineLength / 2, this.props.length, -endLineLength / 2]}></Line>
                <Line ref={(startLine) => { this.startLine = startLine; }} stroke="red" points={[0, -endLineLength, 0, 0]}></Line>
                <Line ref={(endLine) => { this.endLine = endLine; }} stroke="red" points={[this.props.length, -endLineLength, this.props.length, 0]}></Line>
                <Text ref={(text) => { this.text = text }} x={this.props.length / 2 - 100} y={-120} fontSize={100} fontStyle="bold" text={this.props.length + " mm"}></Text>
                {this.EditMeasurementControl(this.props.inputChanged)}
            </Group>);
    }
    EditMeasurementControl(onMeasurementChange) {
        if (onMeasurementChange) {
            return (<URLImage y={-120} x={this.props.length / 2 - 190} src={ "img/pen.png"}/>);
        }
        else return "";
    }

    setLength(length, moveStartPoint) {

        this.text.text(length + " mm");
        let mainLinePoints = this.mainLine.points();
        if (moveStartPoint) {
            let lengthChange = mainLinePoints[2] - length;
            let startLinePoints = this.startLine.points();
            startLinePoints[0] = lengthChange;
            startLinePoints[2] = lengthChange;
            this.startLine.points(startLinePoints);
            mainLinePoints[0] = lengthChange
        }
        else {
            mainLinePoints[2] = length;
            let endLinePoints = this.endLine.points();
            endLinePoints[0] = length;
            endLinePoints[2] = length;
            this.endLine.points(endLinePoints);
        }
        this.mainLine.points(mainLinePoints);
    }
}





export default MeasurementLine;